import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4be46671")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PublicNavBar = _resolveComponent("PublicNavBar")
  const _component_ProductNavBar = _resolveComponent("ProductNavBar")

  return (_openBlock(), _createBlock("header", null, [
    (!_ctx.stage)
      ? (_openBlock(), _createBlock(_component_PublicNavBar, {
          key: 0,
          loggedIn: _ctx.loggedIn
        }, null, 8, ["loggedIn"]))
      : _createCommentVNode("", true),
    (_ctx.stage && _ctx.loaded)
      ? (_openBlock(), _createBlock(_component_ProductNavBar, {
          key: 1,
          loggedIn: _ctx.loggedIn,
          loaded: _ctx.loaded,
          isLoading: _ctx.isLoading,
          stage: _ctx.stage,
          user: _ctx.user,
          projectTitle: _ctx.projectTitle,
          onPublish: _ctx.publish
        }, null, 8, ["loggedIn", "loaded", "isLoading", "stage", "user", "projectTitle", "onPublish"]))
      : _createCommentVNode("", true)
  ]))
})